import { render, staticRenderFns } from "./BatchReserveTable.vue?vue&type=template&id=4a505a3f&scoped=true&"
import script from "./BatchReserveTable.vue?vue&type=script&lang=js&"
export * from "./BatchReserveTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a505a3f",
  null
  
)

export default component.exports